/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    object, func, string,
} from 'prop-types';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import GenericSkeleton from '../../../../GraphqlSkeletonComponents/GenericSkeleton';
import GiftFinderEds from './GiftFinderEds';
import GiftFinderFiveOhEds from './GiftFinderFiveOhEds';

const useStyle = makeStyles((theme) => ({
    fiveOhGiftFinder: {
        display: 'block',
        '& .giftFinderEdsInnerContainer': {
            backgroundColor: 'red',
        },
    },
}));

const GiftFinderFiveOhAbTestContainer = ({
    data, handleSubmitEds, userSubmittedZip, handleChange, onSubmitCheck, zip, validatedZip, setSelectedOccasion, buttonStyle,
}) => {
    const classes = useStyle();
    const [isMounted, setIsMounted] = useState(false);
    const isMobile = useMediaQuery('(max-width: 680px)');

    useEffect(() => {
        setIsMounted(true);
    }, [isMobile]);

    if (!isMounted) {
        return (
            <GenericSkeleton height="112px" width="100%" />
        );
    }

    return (
        isMobile
            ? (
                <GiftFinderFiveOhEds
                    data={data}
                    handleSubmitEds={handleSubmitEds}
                    userSubmittedZip={userSubmittedZip}
                    handleChange={handleChange}
                    onSubmitCheck={onSubmitCheck}
                    zip={zip}
                    validatedZip={validatedZip}
                    setSelectedOccasion={setSelectedOccasion}
                    buttonStyle={buttonStyle}
                />
            )
            : (
                <GiftFinderEds
                    data={data}
                    handleSubmitEds={handleSubmitEds}
                    userSubmittedZip={userSubmittedZip}
                    handleChange={handleChange}
                    onSubmitCheck={onSubmitCheck}
                    zip={zip}
                    validatedZip={validatedZip}
                    setSelectedOccasion={setSelectedOccasion}
                    buttonStyle={buttonStyle}
                />
            )

    );
};

GiftFinderFiveOhAbTestContainer.propTypes = {
    buttonStyle: object,
    data: object.isRequired,
    onSubmitCheck: func.isRequired,
    handleChange: func.isRequired,
    handleSubmitEds: func.isRequired,
    validatedZip: string.isRequired,
    setSelectedOccasion: func.isRequired,
    userSubmittedZip: string.isRequired,
    zip: string,
};

GiftFinderFiveOhAbTestContainer.defaultProps = {
    zip: '',
    buttonStyle: {},
};

export default GiftFinderFiveOhAbTestContainer;
